import { render, staticRenderFns } from "./Embed.vue?vue&type=template&id=27f0a265&"
import script from "./Embed.vue?vue&type=script&lang=js&"
export * from "./Embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f0a265')) {
      api.createRecord('27f0a265', component.options)
    } else {
      api.reload('27f0a265', component.options)
    }
    module.hot.accept("./Embed.vue?vue&type=template&id=27f0a265&", function () {
      api.rerender('27f0a265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Embed.vue"
export default component.exports